"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInnerHeight = getInnerHeight;
exports.getInnerWidth = getInnerWidth;
exports.getInnerSizes = getInnerSizes; // Note: this file and all others under custom-scrollbars are pulled out of the package
// react-scrollbars-custom, because we require a very custom modification to allow
// the vertical scrollbar to work with our "upside-down" message list component in the
// bsweb app (i.e., for that component, the thumb drags and track clicks need to be handled
// backwards from usual). To allow this, there are modifications in index.js, Track.js, and 
// Thumb.js.  All changes are marked with the comment
//
// zipwhip modification from react-scrollbars-custom
//
// to allow possible re-absorption of changes/fixes that might occur in the source library.
// For the same reason, additional customization such as auto-hiding behavior that does not
// have to be added to the original react-scrollbars-custom code itself is handled a level up
// in the ScrollArea component.

/**
 * @description Returns element"s height without padding
 * @param {HTMLElement} el
 * @return {number}
 */

function getInnerHeight(el) {
  var styles = getComputedStyle(el);
  return el.clientHeight - styles.paddingTop.slice(0, -2) - styles.paddingBottom.slice(0, -2);
}
/**
 * @description Returns element"s width without padding
 * @param {HTMLElement} el
 * @return {number}
 */


function getInnerWidth(el) {
  var styles = getComputedStyle(el);
  return el.clientWidth - styles.paddingLeft.slice(0, -2) - styles.paddingRight.slice(0, -2);
}
/**
 * @description Returns element"s dimensions without padding
 * @param {HTMLElement} el
 * @return {{width: number, height: number}}
 */


function getInnerSizes(el) {
  var styles = getComputedStyle(el);
  return {
    width: el.clientHeight - styles.paddingLeft.slice(0, -2) - styles.paddingRight.slice(0, -2),
    height: el.clientHeight - styles.paddingTop.slice(0, -2) - styles.paddingBottom.slice(0, -2)
  };
}